﻿{
  "version": 1,
  "gameId": "sudoku",
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "sudoku.rules.navigationLabel",
    "kickerKey": "sudoku.rules.kicker",
    "titleKey": "sudoku.rules.title",
    "summaryKey": "sudoku.rules.summary",
    "sections": [
      { "id": "setup", "key": "sudoku.rules.setup" },
      { "id": "play", "key": "sudoku.rules.play" },
      { "id": "mistakes", "key": "sudoku.rules.mistakes" },
      { "id": "hint", "key": "sudoku.rules.hint" },
      { "id": "finish", "key": "sudoku.rules.finish" },
      { "id": "challenge", "key": "sudoku.rules.challenge" }
    ],
    "settingsAccess": false
  },
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0, "hintCoins": 10 },
  "cosmetics": {}
}
